module.exports = __webpack_public_path__ + "static/media/paroon-shark.620d9fb0.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/paroon-shark.png
// module id = 328
// module chunks = 0